import _each from 'lodash/each'
import moment from 'moment'

import axios from '../../_framework/axios/trip-dashboard-axios'

export default {
  getters: {
    CustomEvents: (state, getters) => {
      return getters.currentTripDashboardId &&
        getters.Trips[getters.currentTripDashboardId].calendar.custom_events
        ? _each(getters.Trips[getters.currentTripDashboardId].calendar.custom_events, function (e) {
            let d = moment(e.date).toDate()
            e.startDate = d
            e.endDate = d
          })
        : []
    },
    Events: (state, getters) => {
      return getters.currentTripDashboardId
        ? _each(getters.Trips[getters.currentTripDashboardId].events, function (e) {
            let d = moment(e.date).toDate()
            e.startDate = d
            e.endDate = d
          })
        : []
    }
  },
  actions: {
    updateCustomEvents(context, payload) {
      if (this.getters.isOperator) {
        axios
          .post(`${context.getters.currentTripDashboardId}/updateCustomEvents`, payload)
          .then(response => {
            if (response.status === 200) {
              context.commit('updateTripEventsAndTodoItems', response.data)
            }
          })
      }
    }
  }
}
